import { type SectionConfig } from '@/utils/get-matched-section'

export const sectionConfig: SectionConfig = {
  '/accounting/dashboard': {
    title: 'Accounting Dashboard',
    showBreadcrumbs: false
  },
  '/accounting/ap-invoices': {
    title: 'Vendor Invoices'
  },
  '/accounting/ap-triage': {
    title: 'Triage'
  },
  '/accounting/ap-my-queue': {
    title: 'My Queue'
  },
  '/accounting/ap-not-invoices': {
    title: 'Not Invoices'
  },
  '/accounting/ap-approvals': {
    title: 'My Approvals'
  },
  '/accounting/ap-settings': {
    title: 'Approval Levels'
  },
  '/accounting/ap-invoices/[invoiceId]': {
    title: 'Review Vendor Invoice',
    parentBreadcrumb: {
      label: 'Vendor Invoices',
      href: (_params, orgSlug) => `/${orgSlug}/accounting/ap-invoices`
    }
  },
  '/accounting/technician-invoices': {
    title: 'Technician Invoices'
  },
  '/accounting/technician-invoices/[invoiceId]': {
    title: (params) => {
      const p = params as { invoiceId?: string }
      return p?.invoiceId ? `${p.invoiceId}` : 'Technician Invoice'
    },
    parentBreadcrumb: {
      label: 'Technician Invoices',
      href: (_params, orgSlug) => `/${orgSlug}/accounting/technician-invoices`
    }
  },
  '/accounting/technician-payments': {
    title: 'Technician Payments'
  },
  '/accounting/technician-payments/[number]': {
    title: (params) => {
      const p = params as { number?: string }
      return p?.number ? `${p.number}` : 'Technician Payment'
    },
    parentBreadcrumb: {
      label: 'Technician Payments',
      href: (_params, orgSlug) => `/${orgSlug}/accounting/technician-payments`
    }
  },
  '/accounting/vendor-onboarding': {
    title: 'Vendor Onboarding',
    description:
      'Technician companies waiting on their Business Central vendor before Field Ops can approve them.'
  },
  '/accounting/vendor-onboarding/[journeyId]': {
    title: 'Onboarding review',
    parentBreadcrumb: {
      label: 'Vendor Onboarding',
      href: (_params, orgSlug) => `/${orgSlug}/accounting/vendor-onboarding`
    }
  },
  '/accounting/recurring-invoices': {
    title: 'Recurring Invoices'
  },
  '/accounting/capex-invoices': {
    title: 'Capex Invoices'
  },
  '/accounting/past-due': {
    title: 'Past Due Accounts'
  },
  '/accounting/service-mute': {
    title: 'Service Mute'
  },
  '/accounting/customer-invoices/[number]': {
    title: (params) => {
      const p = params as { number?: string }
      return p?.number ? `${p.number}` : 'Customer Invoice'
    },
    parentBreadcrumb: {
      label: 'Customers',
      href: (_params, orgSlug) => `/${orgSlug}/accounting/recurring-invoices`
    }
  }
}
